export const surveyKeys = {
  all: ['all', 'survey'],
  getById: (surveyId: number) => [...surveyKeys.all, 'getById', surveyId],
}
